// Use special Unicode characters to control text directionality when concatenating
// mixed-direction content, such as numbers, prices, or phone numbers in RTL/LTR contexts.
//
// References:
// - Stack Overflow: Handling numeric values in RTL text: https://stackoverflow.com/questions/70577815/concatenate-numeric-value-to-the-right-side-of-an-arabic-string-in-js
// - Wikipedia: Left-to-right mark: https://en.wikipedia.org/wiki/Left-to-right_mark
// - Wikipedia: Right-to-left mark: https://en.wikipedia.org/wiki/Right-to-left_mark
// - Unicode Standard: Directional Formatting Codes: https://unicode.org/reports/tr9/#Directional_Formatting_Codes
export const leftToRightMark = "‎";
export const rightToLeftMark = "‏";
//# sourceMappingURL=directionalMarks.js.map